export default "__VITE_ASSET__D7Jt2Imk__"